import { takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* watchLoginRequest() {
    yield takeLatest(
        appActions.AUTH_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/sys/auth/token',
                appActions.AUTH_CREATE_SUCCESS,
                appActions.AUTH_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchUserGetAllRequest() {
    yield takeLatest(
        appActions.USER_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/user',
                appActions.USER_GET_ALL_SUCCESS,
                appActions.USER_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* authWatcher() {
    yield* watchLoginRequest();
    yield* watchUserGetAllRequest();
}
